import UserAvatarPlaceholder from '../../../UserAvatarPlaceholder';
import ModalEditBrief from '../../../ModalEditBrief';

const BriefAuthor = ({ project = {} }) => {
    const classes = ['briefAuthorWrapper'];

    return (
        <div className={classes.join(' ')}>
            <div className="briefAuthor">
                <div className="userAvatar">
                    {project.profile_picture_url
                        ? <img src={project.profile_picture_url} alt={project.name} />
                        : <UserAvatarPlaceholder className="userAvatar__placeholder" />}
                </div>
                <div className="userMeta">
                    <span className="userName">{project.client}</span>
                    {/*<span className="userPosition">{project.role}</span>*/}
                </div>
            </div>
            <ModalEditBrief projectId={project.id} brief={project.brief} />
        </div>
    );
};

export default BriefAuthor;
